import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  Thumbnail,
  Text,
  TextField,
  Stack,
  DropZone,
  FormLayout,
  Spinner,
  Toast,
  PageActions,
} from "@shopify/polaris";
import axios from "../Assets/Lib/axios";
import { HexColorPicker } from "react-colorful";
import { accessSettings } from "../Helpers";
import axiosDefault from "axios";
import LoadingScreen from "../Components/LoadingScreen";
const Brand = (props) => {
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [item, setItem] = useState({
    primaryColor: "",
    secondaryColor: "",
    logo: "",
  });
  const [file, setFile] = useState();
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFile((file) => acceptedFiles[0]),
    []
  );

  const validImageTypes = [
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/json",
  ];
  const fileUpload = !file && (
    <DropZone.FileUpload actionHint={"Accepts pngs, jpegs, svgs and jsons"} />
  );
  const uploadedFile = file && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div>
        {file.name}{" "}
        <Text variant="bodySm" as="p">
          {file.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const handleChangeSecondaryColor = (newValue) => {
    setItem({ ...item, secondaryColor: newValue });
  };

  const imageKey = useRef("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const sendImage = (file) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "brand");
    form_data.append("logo", file[file.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        setItem({
          ...item,
          logo:
            validImageTypes.indexOf(file[file.length - 1].type) > 0
              ? window.URL.createObjectURL(file[file.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };

  const [activeToast, setActiveToast] = useState(false);
  const toggleActiveToast = useCallback(
    () => setActiveToast((activeToast) => !activeToast),
    []
  );
  const [toastContent, setToastContent] = useState("");
  const toastMarkup = activeToast ? (
    <Toast content={toastContent} onDismiss={toggleActiveToast} />
  ) : null;
  const handleChangePrimaryColor = (newValue) => {
    setItem({ ...item, primaryColor: newValue });
  };

  useEffect(() => {
    axios
      .get(`settings/branding`)
      .then((result) => {
        setIsLoading(false);
        setItem({
          primaryColor: result?.data?.data?.main_color
            ? result?.data?.data?.main_color
            : "",
          secondaryColor: result?.data?.data?.secondary_color
            ? result?.data?.data?.secondary_color
            : "",
          logo: result?.data?.data?.logo ? result?.data?.data?.logo : "",
        });
      })
      .catch((err) => console.log(err));
  }, []);
  return (
    accessSettings() && (
      <Page title="Brand">
        {isLoading ? (
          <Card>
            <div className="spinnerContainer">
              <div className="vertical-center">
                <Spinner size="large" />
              </div>
            </div>
          </Card>
        ) : (
          <FormLayout>
            <Card title="Logo" sectioned>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail size="large" source={item.logo ? item.logo : ""} />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".png,.jpeg,.jpg,.svg,.json"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDrop}
                    onDropAccepted={sendImage}
                  >
                    {uploadedFile}
                    {fileUpload}
                  </DropZone>
                </div>
              </div>
            </Card>

            <Card title="Colors" sectioned>
              <FormLayout.Group>
                <FormLayout>
                  <Text variant="headingSm" as="h6">
                    Primary
                  </Text>
                  <Text variant="bodyMd" as="p" color="subdued">
                    The brand color that appear on your website, social media,
                    and more
                  </Text>
                  <HexColorPicker
                    color={item.primaryColor}
                    onChange={handleChangePrimaryColor}
                  />

                  <TextField
                    value={item.primaryColor}
                    onChange={handleChangePrimaryColor}
                  />
                </FormLayout>
                <FormLayout>
                  <Text variant="headingSm" as="h6">
                    Secondary
                  </Text>
                  <Text variant="bodyMd" as="p" color="subdued">
                    Supporting color used for accents and additional detail
                  </Text>
                  <HexColorPicker
                    color={item.secondaryColor}
                    onChange={handleChangeSecondaryColor}
                  />

                  <TextField
                    value={item.secondaryColor}
                    onChange={handleChangeSecondaryColor}
                  />
                </FormLayout>
              </FormLayout.Group>
            </Card>
          </FormLayout>
          // <Card>
          //   <Card.Section title="Colors"></Card.Section>
          //   <FormLayout>
          //     <FormLayout.Group>
          //       <FormLayout>
          //         <Text variant="bodyMd" as="p" fontWeight="semibold">
          //           Primary Color
          //         </Text>
          // <HexColorPicker
          //   color={item.primaryColor}
          //   onChange={handleChangePrimaryColor}
          // />
          // {/* <ColorPicker
          //   onChange={handleChangePrimaryColor}
          //   color={item.primaryColor}
          // /> */}
          // <TextField
          //   value={item.primaryColor}
          //   onChange={handleChangePrimaryColor}
          // />
          //       </FormLayout>
          //       <FormLayout>
          //         <Text variant="bodyMd" as="p" fontWeight="semibold">
          //           Secondary Color
          //         </Text>
          //         <HexColorPicker
          //           color={item.secondaryColor}
          //           onChange={handleChangeSecondaryColor}
          //         />
          //         {/* <ColorPicker
          //           onChange={handleChangeSecondaryColor}
          //           color={item.secondaryColor}
          //         /> */}
          //         <TextField
          //           value={item.secondaryColor}
          //           onChange={handleChangeSecondaryColor}
          //         />
          //       </FormLayout>
          //     </FormLayout.Group>
          //     <Text variant="bodyMd" as="p" fontWeight="semibold">
          //       Logo
          //     </Text>
          // <div
          //   style={{
          //     display: "flex",
          //     flexDirection: "row",
          //     width: "100%",
          //   }}
          // >
          //   <div style={{ float: "left" }}>
          //     <Thumbnail size="large" source={item.logo ? item.logo : ""} />
          //   </div>
          //   <div
          //     style={{
          //       width: "100%",
          //       marginLeft: "10px",
          //     }}
          //   >
          //     <DropZone
          //       accept=".png,.jpeg,.jpg,.svg,.json"
          //       //   type="file"
          //       allowMultiple={false}
          //       onDrop={handleDropZoneDrop}
          //       onDropAccepted={sendImage}
          //     >
          //       {uploadedFile}
          //       {fileUpload}
          //     </DropZone>
          //   </div>
          // </div>
          //   </FormLayout>
          // </Card>
        )}
        <PageActions
          primaryAction={{
            content: "Save",
            onClick: handleSave,
            loading: isSaving && true,
          }}
        />
        {toastMarkup}
        {isImageUploading ? <LoadingScreen /> : null}
      </Page>
    )
  );

  function handleSave() {
    setIsSaving(true);
    const form_data = new FormData();
    item.primaryColor && form_data.append("main_color", item.primaryColor);
    item.secondaryColor &&
      form_data.append("secondary_color", item.secondaryColor);
    file && form_data.append("logo", imageKey.current);
    form_data.append("_method", "PATCH");
    axios
      .post(`settings/branding`, form_data)
      .then((res) => {
        setIsSaving(false);
        setToastContent("Changes have been saved successfully");
        toggleActiveToast();
      })
      .catch(function (error) {
        if (error.response) {
          setToastContent(error.response.data.message);
          toggleActiveToast();
          setIsSaving(false);
        }
      });
  }
};

export default Brand;
